export const BLOG_LIST = "BLOG_LIST";
export const BLOG_LIST_SUCCESS = "BLOG_LIST_SUCCESS";
export const BLOG_LIST_FAIL = "BLOG_LIST_FAIL";

/////****************Blog Details******************////
export const BLOG_DETAIL = "BLOG_DETAIL";
export const BLOG_DETAIL_SUCCESS = "BLOG_DETAIL_SUCCESS";
export const BLOG_DETAIL_FAIL = "BLOG_DETAIL_FAIL";
